<template>
  <div id="lernzettel" class="zweigi" v-if="lernzettel">
    <h1 class="text-center is-size-1">{{lernzettel.title}}</h1>
    <div>
      <div class="main" v-html="lernzettel.content"></div>
    </div>
    <v-divider></v-divider>
    <v-card-text class="text">
      <v-chip-group column v-if="lernzettel.kategorien && kategorien.kategorien">
        <div v-for="chip in kategorien.kategorien" :key="chip.title"><v-chip color="#686de0" v-if="typeof lernzettel.kategorien.find(x => x == chip.slug) != 'undefined'">{{chip.title}}</v-chip></div>
        <div v-for="autor in autoren.autoren" :key="autor.vorname"><v-chip color="#0fb9b1" v-if="typeof lernzettel.autoren.find(x => x == autor.mail) != 'undefined'">{{autor.vorname + ' ' + autor.nachname}}</v-chip></div>
      </v-chip-group>
    </v-card-text>
  </div>
</template>

<style scoped>
.main >>> h1{
  color: #1f3864;
}
.main >>> h2{
  color: #2f5496;
}
h2 {
  color: #2f5496;
}
.main >>> h4{
  color: #8eaadb;
}
.main >>> ol{
  margin-block-start: 0px;
}
.main >>> table{
  overflow-x: auto;
  overflow-y: hidden;
}
.main >>> table{
  overflow-x: auto;
  overflow-y: hidden;
  max-width: 100%;
  display: block;
}
.main >>> .MathJax_Display{
      overflow-x: auto;
      overflow-y: hidden;
}
.main >>> .MathJax_Preview{
      display: none;
}
.main >>> p {
  overflow-x: auto;
}
.pe{
  padding-bottom: 16px;
}
h1{
  font-family: forgetica;
}
</style>

<script>
  import { db } from '../db'
  const lernzettelp = db.collection('blog');
  export default {
    name: 'lernzettel',
    firestore: {
      sitemap: lernzettelp.doc('sitemap'),
      autoren: lernzettelp.doc('autoren'),
      kategorien: lernzettelp.doc('kategorien')
    },
    data() {
      return {
        lernzettel: {},
        sitemap: {},
        autoren: {},
        kategorien: {}
      }
    },
    watch: {
      $route: {
        immediate: true,
        handler(to, from) {
          lernzettelp.doc(this.$route.params.lernzettel).get().then(snapshot => this.lernzettel = snapshot.data()).then(() => this.$Progress.finish());
        }
      }
    },
    mounted: function(){
      if(this.$route.params.lernzettel !== ''){
        lernzettelp.doc(this.$route.params.lernzettel).get().then(snapshot => this.lernzettel = snapshot.data()).then(() => this.$Progress.finish());
      }
    },
    updated: function () {
      this.$nextTick(function () {
        MathJax.Hub.Queue(["Typeset",MathJax.Hub])
      })
    },
    metaInfo(){
      if(this.lernzettel){
      return {
        title: "Wach - " + this.lernzettel.title
      }
      }
    }
  }
</script>